module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I will show you a philtre without potions, without herbs, without any witch’s incantation: if you wish to be loved, love.")])]), _vm._v(" "), _c('p', {
    staticClass: "fmr"
  }, [_vm._v("Seneca")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e32c612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Fm01.vue
// module id = 66
// module chunks = 0